// El usuario cambia SU clave (Rodrigo, 2026-10-25). Exige la actual; al cambiarla se cierran todas sus
// sesiones (también esta), así que vuelve a ingresar con la nueva.
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../api/cliente';
import { PanelError } from '../comun/Estados';
import { Modal } from '../comun/Modal';
import { LARGO_MINIMO_CLAVE } from './Login';
import { useSesion } from './SesionContexto';

const MINIMO = LARGO_MINIMO_CLAVE;

export function CambiarClave({ alCerrar }: { alCerrar: () => void }) {
  const sesion = useSesion();
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [repetida, setRepetida] = useState('');
  const cambiar = useMutation({
    mutationFn: () => api.post('/auth/clave', { claveActual: actual, claveNueva: nueva }),
  });
  const problema =
    nueva.length > 0 && nueva.length < MINIMO
      ? `La clave nueva debe tener al menos ${MINIMO} caracteres`
      : repetida.length > 0 && repetida !== nueva
        ? 'Las dos claves nuevas no coinciden'
        : nueva.length > 0 && nueva === actual
          ? 'La clave nueva no puede ser igual a la actual'
          : null;
  const lista = !!actual && nueva.length >= MINIMO && nueva === repetida && nueva !== actual;
  if (cambiar.isSuccess)
    return (
      <Modal titulo="Clave cambiada" ancho="angosto" alCerrar={() => void sesion.cerrar()}>
        <p>
          Tu clave quedó cambiada. Por seguridad se cerraron tus sesiones: ingresa con la nueva.
        </p>
        <div className="acciones">
          <button
            type="button"
            className="primario"
            data-autofoco
            onClick={() => void sesion.cerrar()}
          >
            Ingresar de nuevo
          </button>
        </div>
      </Modal>
    );
  return (
    <Modal titulo="Cambiar mi clave" ancho="angosto" alCerrar={alCerrar}>
      <form
        className="formulario-clave"
        onSubmit={(e) => {
          e.preventDefault();
          if (lista && !cambiar.isPending) cambiar.mutate();
        }}
      >
        <label>
          Clave actual
          <input
            type="password"
            autoComplete="current-password"
            value={actual}
            onChange={(e) => setActual(e.target.value)}
            data-autofoco
          />
        </label>
        <label>
          Clave nueva (mínimo {MINIMO} caracteres)
          <input
            type="password"
            autoComplete="new-password"
            value={nueva}
            onChange={(e) => setNueva(e.target.value)}
          />
        </label>
        <label>
          Repite la clave nueva
          <input
            type="password"
            autoComplete="new-password"
            value={repetida}
            onChange={(e) => setRepetida(e.target.value)}
          />
        </label>
        {problema && <p className="aviso-linea tono-aviso">{problema}</p>}
        {cambiar.isError && <PanelError error={cambiar.error} alCerrar={() => cambiar.reset()} />}
        <div className="acciones">
          <button type="button" onClick={alCerrar}>
            Cancelar (Esc)
          </button>
          <button type="submit" className="primario" disabled={!lista || cambiar.isPending}>
            {cambiar.isPending ? 'Cambiando…' : 'Cambiar clave'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
